import styled from 'styled-components';

import { PADDING_CONTENT_PAGE } from '../../../globals';


export const StyledTextWrapper = styled.div`
  padding: 0px ${PADDING_CONTENT_PAGE}px 12px ${PADDING_CONTENT_PAGE}px;
`;



// WEBPACK FOOTER //
// ./src/common/TextWrapper/styles/StyledTextWrapper.js